module.exports = __webpack_public_path__ + "img/img11.d9f00b0d.png";